import { useAppStore } from "../../store";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { RouteContext } from "@ant-design/pro-components";
import { Button, theme } from "antd";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CollapseAction = function CollapseAction() {
  var menuCollapsed = useAppStore(function (s) {
    return s.menuCollapsed;
  });
  var setMenuCollapsed = useAppStore(function (s) {
    return s.setMenuCollapsed;
  });
  var themeInfo = theme.useToken();
  var token = themeInfo.token;
  return /*#__PURE__*/_jsx("div", {
    onClick: function onClick() {
      return setMenuCollapsed(!menuCollapsed);
    },
    style: {
      padding: menuCollapsed ? "0 ".concat(token.padding, "px") : "0 ".concat(token.paddingMD, "px"),
      height: 40,
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      color: menuCollapsed ? token.colorPrimaryText : token.colorTextSecondary
    },
    children: menuCollapsed ? /*#__PURE__*/_jsx(MenuUnfoldOutlined, {}) : /*#__PURE__*/_jsx(MenuFoldOutlined, {})
  });
};
export var actionsRender = function actionsRender(props) {
  if (props.isMobile) {
    return [/*#__PURE__*/_jsx(CollapseAction, {}, "action")];
  }
  return [];
};
export var LogoActionWithCollapseAction = function LogoActionWithCollapseAction(props) {
  var setMenuCollapsed = useAppStore(function (s) {
    return s.setMenuCollapsed;
  });
  var themeInfo = theme.useToken();
  var token = themeInfo.token;
  return /*#__PURE__*/_jsx(RouteContext.Consumer, {
    children: function children(value) {
      var isMobile = value.isMobile,
        collapsed = value.collapsed,
        layout = value.layout;
      return /*#__PURE__*/_jsxs("div", {
        style: {
          display: "flex",
          alignItems: "center"
        },
        children: [isMobile ? /*#__PURE__*/_jsx(Button, {
          type: "text",
          onClick: function onClick() {
            return setMenuCollapsed(!collapsed);
          },
          style: {
            marginRight: token.marginXS,
            height: 40,
            display: "flex",
            alignItems: "center",
            color: token.colorTextSecondary
          },
          children: collapsed ? /*#__PURE__*/_jsx(MenuUnfoldOutlined, {}) : /*#__PURE__*/_jsx(MenuFoldOutlined, {})
        }) : null, /*#__PURE__*/_jsx("img", {
          style: {
            height: 30
          },
          alt: (props === null || props === void 0 ? void 0 : props.title) || "logo",
          src: layout === "side" ? "https://webcdn.starcharge.com/resources/logo/2411/logo.svg" : "https://webcdn.starcharge.com/resources/logo/2411/black.svg"
        })]
      });
    }
  });
};